import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactList = () => {
  const [userContactList, setUserContactList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const callApiContactList = async () => {
  try {
    setLoading(true);

    const url = process.env.REACT_APP_API_URL + "contact/alluser";
    
    const response = await axios.get(url);
    
    setUserContactList(response.data || []);
    setFilteredList(response.data || []);
  } catch (error) {
    
    toast.error(
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch contact list"
    );
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    callApiContactList();
  }, []);

  useEffect(() => {
    const filtered = userContactList.filter((item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.subject?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredList(filtered);
  }, [searchTerm, userContactList]);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = filteredList.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.max(
    1,
    Math.ceil(filteredList.length / itemsPerPage)
  );

 const renderStatusBadge = (status) => {
    const s = status?.toLowerCase() || 'pending';
    switch (s) {
      case 'responded':
        return <span className="badge-active bg-success text-white px-2 py-1 rounded small">Email Sent</span>;
      case 'in progress':
        return <span className="badge-warning-custom bg-warning text-dark px-2 py-1 rounded small">In Progress</span>;
      default:
        return <span className="badge-inactive bg-secondary text-white px-2 py-1 rounded small">Pending</span>;
    }
  };

  return (
    <>
<div className="main-card shadow-sm">
      <ToastContainer />
      <div className="toolbar-container d-flex justify-content-between align-items-center p-3">
        <h2 className="page-title mb-0">Contact Management</h2>
        <div className="d-flex align-items-center gap-3">
          <span className="results-count text-muted">{filteredList.length} inquiries</span>
          <input
            type="text"
            className="search-box form-control"
            placeholder="Search by Name or Email"
            style={{ width: '250px' }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="table-header-panel bg-info text-white p-2 px-3">
        Customer Inquiry List
      </div>

      <div className="table-responsive">
        <table className="custom-table table table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th style={{ width: '60px' }}>SR</th>
              <th>Name</th>
              <th>Email</th>
              <th>Subject</th>
              <th>Message</th>
              {/* Removed manual padding here */}
              <th className="text-center">Status</th>
              <th className="text-center">Final Status</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="text-center p-5">Loading Inquiries...</td></tr>
            ) : (
              currentItems.map((item, index) => (
                <tr key={item.srno} className="align-middle">
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td className="fw-bold">{item.name || "undefined"}</td>
                  <td>{item.email || "undefined"}</td>
                  <td><span className="text-muted small">{item.subject || "undefined"}</span></td>
                  <td>
                    <div className="text-truncate" style={{ maxWidth: "120px" }} title={item.message}>
                      {item.message || "undefined"}
                    </div>
                  </td>
                  {/* Applied text-center to keep badges aligned */}
                  <td className="text-center">{renderStatusBadge(item.responseStatus)}</td>
                  <td className="text-center" style={{ whiteSpace: "nowrap" }}>
                    <span className={item.finalStatus === 1 ? 'text-success' : 'text-warning'} style={{ fontWeight: '600' }}>
                      {item.finalStatus === 1 ? '● Resolved' : '● Open'}
                    </span>
                  </td>
                 <td className="text-center">
                  <button
                   className="btn btn-info btn-sm px-2 py-1 me-1"
                    onClick={() => {
                      setSelectedInquiry(item);
                      setShowModal(true);
                    }}
                  >
                    View
                  </button>

                  <Link
                    to={`/contactupdate/${item.srno}`}
                    className="btn btn-outline-info btn-sm px-2 py-1"
                  >
                    Edit
                  </Link>
                </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center align-items-center gap-2 p-3">

      <button
        className="btn btn-outline-secondary btn-sm"
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        Previous
      </button>

      <span className="fw-bold">
        Page {currentPage} of {totalPages}
      </span>

      <button
        className="btn btn-outline-secondary btn-sm"
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        Next
      </button>

    </div>
 </div>

{showModal && selectedInquiry && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Inquiry Details</h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>

        <div className="modal-body">

          <p><strong>Name:</strong> {selectedInquiry.name || "N/A"}</p>

          <p><strong>Email:</strong> {selectedInquiry.email || "N/A"}</p>

          <p><strong>Subject:</strong> {selectedInquiry.subject || "N/A"}</p>

          <p><strong>Message:</strong> {selectedInquiry.message || "N/A"}</p>

          <p>
            <strong>Status:</strong>{" "}
            {selectedInquiry.responseStatus || "Pending"}
          </p>

          <p>
            <strong>Final Status:</strong>{" "}
            {selectedInquiry.finalStatus === 1 ? "Resolved" : "Open"}
          </p>

        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  </div>
)}

</>

  );
}
export default ContactList;